import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
  getMyWorksToAdministrate: {
    apiServiceMethodName:
      ModulesConfigMap[ModulesMap.DONE_WORKS_MY_WORKS_TO_ADMINISTRATE].GET_MY_WORKS_TO_ADMINISTRATE
  },
}